import TextInput from "@builder/components/general/TextInput";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType } from "@common/build/types";
import { useEffect, useState } from "react";
import Info from "@builder/components/editable/editor/Info";

const CustomPaymentAction = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const [paymentDetails, setPaymentDetails] = useState<any>(
        actionStep?.action?.data || {
            paymentName: "",
            addedFee: { value: "", type: "$" },
            addedDiscount: { value: "", type: "$" }
        }
    );
    const dispatch = useAppDispatch();

    const updateNodeProperty = (propertyPath: string[], value: any) => {
        setPaymentDetails((prev: any) => {
            const newDetails = { ...prev };

            let current = newDetails;
            for (let i = 0; i < propertyPath.length - 1; i++) {
                current[propertyPath[i]] = { ...current[propertyPath[i]] };
                current = current[propertyPath[i]];
            }

            current[propertyPath[propertyPath.length - 1]] = value;

            return newDetails;
        });
    };

    // const handleAmount = (value: string, key: "addedFee" | "addedDiscount") => {
    //     updateNodeProperty([key, "value"], value);
    // };

    // const handleToggle = (key: "addedFee" | "addedDiscount") => {
    //     setPaymentDetails((prevDetails: any) => {
    //         const updatedDetails = { ...prevDetails };
    //         const updatedKey = { ...updatedDetails[key] };

    //         updatedKey.type = updatedKey.type === "$" ? "%" : "$";

    //         updatedDetails[key] = updatedKey;

    //         return updatedDetails;
    //     });
    // };

    const handlePaymentNameChange = (value: string) => {
        updateNodeProperty(["paymentName"], value);
    };

    useEffect(() => {
        const action = {
            type: ActionType.CUSTOM_PAYMENT,
            data: paymentDetails
        };

        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id as string, item: updatedStep as ActionEditorItem }));
        }
    }, [paymentDetails, actionStep, dispatch, id]);

    return (
        <div className="function-add-cart-note-wrapper">
            <div className="function-add-cart-note">
                <TextInput
                    title="Payment name"
                    callback={handlePaymentNameChange}
                    value={paymentDetails.paymentName || ""}
                    className="actions-tab-input"
                    placeholder="Enter a name for this custom payment type."
                />

                {/* <div className="function-add-cart-note-wrapper">
                    <TextInput
                        title="Add fee"
                        callback={value => handleAmount(value, "addedFee")}
                        value={paymentDetails.addedFee?.value || ""}
                        className="actions-tab-input"
                        placeholder="Amount"
                        icon={{
                            src: ["./dollar-sign.svg", "./percentage-sign.svg"],
                            callback: (event: React.MouseEvent) => {
                                event.preventDefault();
                                handleToggle("addedFee");
                            }
                        }}
                        isPercent={paymentDetails.addedFee?.type === "%"}
                    />
                    <TextInput
                        title="Add discount"
                        callback={value => handleAmount(value, "addedDiscount")}
                        value={paymentDetails.addedDiscount?.value || ""}
                        className="actions-tab-input"
                        placeholder="Amount"
                        icon={{
                            src: ["./dollar-sign.svg", "./percentage-sign.svg"],
                            callback: (event: React.MouseEvent) => {
                                event.preventDefault();
                                handleToggle("addedDiscount");
                            }
                        }}
                        isPercent={paymentDetails.addedDiscount?.type === "%"}
                    />
                </div> */}

                <div className="custom-payment-info-wrapper">
                    <Info />
                </div>
            </div>
        </div>
    );
};

export default CustomPaymentAction;
